import Lottie from "react-lottie-player";
import LoadingJson from "assets/gifs/CarTypes.json";
import LoadingJsonLight from "assets/gifs/CarTypesLight.json";
import { getTheme } from "utils/v2/theme";
const LoadingLottiePc = () => {
  const theme = getTheme();
  return (
    <div className="lottieStylesPc">
      <Lottie
        loop
        animationData={theme === "dark" ? LoadingJsonLight : LoadingJson}
        play
        style={{ width: 200, height: 200 }}
      />
    </div>
  );
};

export default LoadingLottiePc;
